import React, {useState} from "react";
import css from "./index.module.scss";
import DefaultLayout from "layouts/default";
import Button from "@/components/button";


export default function ThankYouPage() {
  return <DefaultLayout
    title="Edit Profile | Lazy Prompts"
    description="Sell your AI prompts on Lazy Prompts."
    light
  >
    <section className={`light ${css.thanks}`}>
      <div className="sectionInner">
        <h2>Success!</h2>
        <p>Your profile has been updated.</p>
        <Button label="Account" href="/account"/>
      </div>
    </section>

  </DefaultLayout>;
}
